<template>
  <div class="del_sate_check_container">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label='"全部" + "(" + num1 + ")"' name="first"></el-tab-pane>
      <el-tab-pane :label='"待店铺响应" + "(" + num2 + ")"' name="second"></el-tab-pane>
      <el-tab-pane :label='"店铺已整改-待复查" + "(" + num3 + ")"' name="third"></el-tab-pane>
      <el-tab-pane :label='"店铺已申诉-待评定" + "(" + num4 + ")"' name="fourth"></el-tab-pane>
      <el-tab-pane :label='"已结案" + "(" + num5 + ")"' name="fifth"></el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getLoginType } from "@/libs/until";

export default {
  name: "dealState",
  props: {
    searchData: {
      type: Object,
    },
  },
  // watch: {
  //   searchData(val, old) {
  //     this.searchData = val;
  //   },
  // },
  data() {
    return {
      num1: 0,
      num2: 0,
      num3: 0,
      num4: 0,
      num5: 0,
      activeName: 'first',
      // activeHeight: 0,
      // ifStateDel: false,
      // radio: "11",
      // stateCount: {
      //   allCount: 0,
      //   inCount: 0,
      //   status9: 0,
      // },
      // titleCount: 0,
      // statusNameTitle: "全部",
      // loginKefu: true,
      // logintype: getLoginType(),
      // statusData: [
      //   [{ name: "全部", count: "allCount", label: "" }],
      //   [{ name: "待店铺响应", count: "status1", label: '1,13' }],
      //   [
      //     { name: "店铺已整改-待复查", count: "status2", label: 2 },
      //     { name: "店铺已申诉-待评定", count: "status5", label: 5 },
      //   ],
      //   [
      //     { name: "店铺整改不合格-待处理", count: "status4", label: 4 },
      //     { name: "店铺未响应-待处理", count: "status6", label: 6 },
      //   ],
      //   [{ name: "二次申诉待处理", count: "status8", label: 8 }],
      //   [{ name: "已结案", count: "status9", label: 9 }],
      // ],
      // statusHeader: [
      //   "全部",
      //   "待违规店铺响应",
      //   "待我核查",
      //   "待我处理",
      //   "待我处理",
      //   "处理完成",
      // ],
    };
  },
  created() {
    this.$nextTick(() => {
      this.getSatetCount();
    });
    if (
      this.logintype != "KEFU" ||
      this.logintype != "HCM" ||
      this.logintype != "HCMSUB"
    ) {
      this.loginKefu = true;
    } else this.loginKefu = false;
  },
  methods: {
    handleClick(tab, event) {
      // 已结案 9 店铺已申诉-待评定 5 店铺已整改待复查2 待店铺响应1,13
      if (tab.index == 0) {
        this.radio = ''
      } else if (tab.index == 1) {
        this.radio = '1,13'
      } else if (tab.index == 2) {
        this.radio = '2'
      } else if (tab.index == 3) {
        this.radio = '5'
      } else if (tab.index == 4) {
        this.radio = '9'
      }
      this.$emit("statusTabale", this.radio);
    },
    getSatetCount(val) {
      //获取状态数量
      fetch({
        url: "hcm/hcmReport/getCountByBmc",
        method: "get",
        params: val ? val : this.searchData,
      }).then((res) => {
        if (res.status == "10000") {
          let allNum = 0
          let twoNum = 0
          for (let a in res.data) {
            // 待店铺响应1,13 店铺已整改待复查 2 店铺已申诉-待评定 5 已结案 9
            if (res.data[a].status == 1) {
              allNum += Number(res.data[a].count)
              twoNum += Number(res.data[a].count)
            } else if (res.data[a].status == 13) {
              allNum += Number(res.data[a].count)
              twoNum += Number(res.data[a].count)
            }  else if (res.data[a].status == 2) {
              this.num3 = res.data[a].count
              allNum += Number(res.data[a].count)
            } else if (res.data[a].status == 5) {
              this.num4 = res.data[a].count
              allNum += Number(res.data[a].count)
            } else if (res.data[a].status == 9) {
              this.num5 = res.data[a].count
              allNum += Number(res.data[a].count)
            }
          }
          this.num1 = allNum
          this.num2 = twoNum
        }
      });
    },
  },
};
</script>

<style  lang="scss">
.del_sate_check_container {
  .el-radio-button:first-child .el-radio-button__inner {
    margin-right: 10px;
  }
  .el-radio-button__inner {
    border-left: 1px solid #DCDFE6;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    border-radius: 0 !important;
  }
  .statusType {
    padding-top: 16px;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #409eff;
  }
  position: relative;
  .el-radio__inner {
    display: none;
  }
  .el-col-offset-18 {
    text-align: right;
  }
  .del_sate_check {
    border: 1px solid #c0c4cc;
    padding: 0 14px;
    box-sizing: border-box;
    line-height: 54px;
    width: 100%;
    height: 54px;
    background: rgba(217, 217, 217, 0.1);
    border-radius: 2px;
    &:hover,
    &:visited {
      border: 1px solid #91d5ff;
    }
  }
  .el-col-offset-20 {
    text-align: right;
  }
  .del_sate_taggle_down {
    width: 100%;
    position: absolute;
    top: 75px;
    left: 0;
    background: #fff;
    border: 1px solid #d4d4d4;
    padding: 20px 0;
    z-index: 555;
    .el-row {
      margin-bottom: 7px;
    }
    .el-col-4 {
      text-align: right;
      padding-right: 42px;
    }
    .el-checkbox.is-bordered {
      height: 32px;
      line-height: 32px;
      padding: 0 15px;
    }
    .el-checkbox__label {
      padding-left: 0px;
    }
    .el-checkbox__inner {
      display: none;
    }
  }
}
</style>
